import { createSlice } from '@reduxjs/toolkit';
import { getHRControlListThunk } from './HRControl.thunk';
import { HRControlState } from './HRControl.type';
import { RootState } from '../../store';

const SLICE_NAME = 'hrControl';

const initialState: HRControlState = {
  items: [],
  isLoading: false,
  pagination: undefined,
};

export const hrControlSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setHrControlList: (state, action) => ({
      ...state,
      items: action.payload,
    }),
  },
  extraReducers: builder => {
    builder.addCase(getHRControlListThunk.pending, state => {
      state.isLoading = true;
    });
    builder.addCase(getHRControlListThunk.fulfilled, (state, { payload }) => {
      const { data, pagination } = payload;
      state.isLoading = false;
      state.items = data;
      state.pagination = {
        currentPage: pagination.current_page,
        lastPage: pagination.last_page,
        perPage: pagination.per_page,
        from: pagination.from,
        to: pagination.to,
        total: pagination.total,
      };
    });
    builder.addCase(getHRControlListThunk.rejected, state => {
      state.isLoading = false;
    });
  },
});

export const { setHrControlList } = hrControlSlice.actions;

export const getHRControlList = (state: RootState) => state.hrControl.items;

export const getHRControlListPagination = (state: RootState) =>
  state.hrControl.pagination;

export default hrControlSlice.reducer;
